<template>
  <div>
    <News></News>
    <Announcement></Announcement>
  </div>
</template>
<script>
import Announcement from "./Announcement.vue";
import News from "./News.vue";

export default {
  components: {
    Announcement: Announcement,
    News: News,
  },
};
</script>
<style lang="scss" scoped>
h1 {
  color: #931b22 !important;
  font-size: 20px;
  font-weight: bold;
  padding: 10px;
}
a {
  color: #3e3e3e;
  :hover {
    color: #931b22 !important;
  }
}
</style>
